import { Stripe } from '@stripe/stripe-js';
import { atom } from 'jotai';

const stripeAtom = atom<Stripe | null>(null);

export { stripeAtom };
